"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const next13_utils_common_transform_object_2_ga_format_1 = __importDefault(require("@gerenciatd/next13.utils.common.transform-object-2-ga-format"));
const next13_utils_common_is_front_app_1 = __importDefault(require("@gerenciatd/next13.utils.common.is-front-app"));
// funcion para enviar a gtag eventos
const sendGaEvent = (contextObj) => {
    const gaObject = (0, next13_utils_common_transform_object_2_ga_format_1.default)(contextObj);
    if ((0, next13_utils_common_is_front_app_1.default)() && window && window.gtag) {
        window.gtag('event', gaObject);
    }
    return gaObject;
};
exports.default = sendGaEvent;
//# sourceMappingURL=index.js.map